<script setup>
  import { useI18n } from 'vue-i18n';
  import UpgradeBlock from '@/components/UpgradeBlock.vue';
  import { useUserUpgrades } from '@/composables/useUserUpgrades';

  const { t } = useI18n();
  const { upgrade } = useUserUpgrades({ minMemberLevel: 49 });
</script>

<template>
  <UpgradeBlock :productText="t('upgrade.products.proForecasts')" :upgrade="upgrade" clickLocation="Pro Forecast Banner" />
</template>